export default __webpack_public_path__ + "static/media/gallery13.b206c107.jpg";